var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bo6-overlay-page"},[_c('WZOverlayBO6',{attrs:{"params":_vm.params}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }